import { ComponentThemeType } from '@/cl/theme/theme.hooks';

export const SettingsCardTheme: ComponentThemeType = (currentTheme) => ({
  baseStyle: {
    container: {
      display: 'flex',
      gap: '16px',
    },
    icon: {
      color: currentTheme.colors.neutral.black,
    },
    textContainer: {
      flexDirection: 'column',
      flex: 1,
      padding: 0,
      textAlign: 'left',
    },
    content: {
      ...currentTheme.textStyles.body2Semi,
      color: currentTheme.colors.neutral.black,
    } as never,
    helperText: {
      ...currentTheme.textStyles.body4,
      color: currentTheme.colors.neutral.darkest,
    } as never,
  },
});
